import { useState } from "react"
import axios from "axios"
import { baseURL } from "constants/api"

// Генерация недостающих фото блюд через бэкенд (OpenAI Images, ключ на сервере).
// Бэкенд ведёт счётчик за всё время и применяет лимит бесплатной версии.
// При достижении лимита эндпоинт отвечает 403 error_generation_limit_reached.

const useDishImageGeneration = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  // Признак, что упёрлись в лимит бесплатной версии — фронт показывает окно
  const [limitReached, setLimitReached] = useState(false)

  // Генерирует фото одного блюда. Возвращает data-URI или null.
  const generateImage = async (restaurant_id, title, description = "") => {
    setLoading(true)
    setError("")

    try {
      const response = await axios.post(`${baseURL}/menu/generate-image`, {
        restaurant_id,
        title,
        description,
      })
      return response.data?.image || null
    } catch (err) {
      if (err.response?.status === 403 && err.response?.data?.message === "error_generation_limit_reached") {
        setLimitReached(true)
        return null
      }
      const errorMessage =
        err.response?.data?.message || err.message || "Ошибка при генерации изображения"
      setError(errorMessage)
      console.error("Dish image generation error:", err)
      return null
    } finally {
      setLoading(false)
    }
  }

  // Текущее состояние лимита: { used, limit, remaining }
  const getStatus = async (restaurant_id) => {
    try {
      const response = await axios.get(`${baseURL}/menu/generation-status/${restaurant_id}`)
      return response.data
    } catch (err) {
      console.error("Generation status error:", err)
      return null
    }
  }

  return {
    loading,
    error,
    limitReached,
    setLimitReached,
    generateImage,
    getStatus,
  }
}

export default useDishImageGeneration
